var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.logo && _vm.data.logo.image_url!=null)?_c('img',{class:{ inherited: _vm.data.logo.inherited },attrs:{"width":"220","height":"64","src":_vm.data.logo.image_url}}):(_vm.data.logo)?_c('div',{staticClass:"logo-preview",class:{ inherited: _vm.data.logo.inherited },style:({
    fontSize: _vm.data.logo.size,
    fontStyle: (_vm.data.logo.italic) ? 'italic' : 'normal',
    fontWeight: (_vm.data.logo.bold) ? 'bold' : 'normal',
    fontFamily: _vm.data.logo.font,
    color: _vm.data.logo.color,
    backgroundColor: _vm.data.logo.background,
  })},[_vm._v(_vm._s(_vm.data.logo.text)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23eb84aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/org/components/Logo/LogoItem.vue
// module id = null
// module chunks = 